import { createActionName } from './naming';
import * as types from './actionsTypes';

export const initState = reducerName => ({
  type: createActionName(reducerName, types.INIT_STATE)
});

export const requestRecoveryForm = (reducerName, payload) => ({
  type: createActionName(reducerName, types.REQUEST_RECOVERY_FORM),
  payload
});

export const recoveryFormFields = (reducerName, payload) => ({
  type: createActionName(reducerName, types.RECOVERY_FORM_FIELDS),
  payload
});

export const sendForm = (reducerName, payload) => ({
  type: createActionName(reducerName, types.SEND_FORM),
  payload
});

export const validate = (reducerName, payload) => ({
  type: createActionName(reducerName, types.VALIDATE),
  payload
});

export const setErrors = (reducerName, payload) => ({
  type: createActionName(reducerName, types.SET_ERRORS),
  payload
});

export const clearAllErrors = (reducerName, payload) => ({
  type: createActionName(reducerName, types.CLEAR_ALL_ERRORS),
  payload
});

export const finishedSendRequest = (parentName, codeResponse, hasSuccess) => ({
  type: createActionName(parentName, types.FINISHED_SEND_REQUEST),
  payload: { codeResponse, hasSuccess }
});

export const finishedRecoveryRequest = (
  parentName,
  codeResponse,
  hasSuccess
) => ({
  type: createActionName(parentName, types.FINISHED_RECOVERY_REQUEST),
  payload: { codeResponse, hasSuccess }
});

export const setSendFormResponse = (reducerName, payload) => ({
  type: createActionName(reducerName, types.SET_SEND_FORM_RESPONSE),
  payload
});

// FIELDS
export const changeFieldTitle = (reducerName, payload) => ({
  type: createActionName(reducerName, types.CHANGE_FIELD_TITLE),
  payload
});
export const changeFieldTypeId = (reducerName, payload) => ({
  type: createActionName(reducerName, types.CHANGE_FIELD_TYPE_ID),
  payload
});
export const changeFieldLocaleCode = (reducerName, payload) => ({
  type: createActionName(reducerName, types.CHANGE_FIELD_LOCALE_CODE),
  payload
});
export const changeFieldCostExecution = (reducerName, payload) => ({
  type: createActionName(reducerName, types.CHANGE_FIELD_COST_EXECUTION),
  payload
});
export const changeFieldMaxExecutions = (reducerName, payload) => ({
  type: createActionName(reducerName, types.CHANGE_FIELD_MAX_EXECUTIONS),
  payload
});
export const changeFieldDesc = (reducerName, payload) => ({
  type: createActionName(reducerName, types.CHANGE_FIELD_DESC),
  payload
});
export const changeFieldCheckType = (reducerName, payload) => ({
  type: createActionName(reducerName, types.CHANGE_FIELD_CHECK_TYPE),
  payload
});
export const changeFieldLinks = (reducerName, payload) => ({
  type: createActionName(reducerName, types.CHANGE_FIELD_LINKS),
  payload
});
export const changeFieldRandomLink = (reducerName, payload) => ({
  type: createActionName(reducerName, types.CHANGE_FIELD_RANDOM_LINK),
  payload
});
export const changeFieldAdultContent = (reducerName, payload) => ({
  type: createActionName(reducerName, types.CHANGE_FIELD_ADULT_CONTENT),
  payload
});
export const changeFieldSoftwareInstall = (reducerName, payload) => ({
  type: createActionName(reducerName, types.CHANGE_FIELD_SOFTWARE_INSTALL),
  payload
});
export const changeFieldTimeChecking = (reducerName, payload) => ({
  type: createActionName(reducerName, types.CHANGE_FIELD_TIME_CHECKING),
  payload
});
export const changeFieldTimePerform = (reducerName, payload) => ({
  type: createActionName(reducerName, types.CHANGE_FIELD_TIME_PERFORM),
  payload
});
export const changeFieldExecutorExecutionInterval = (reducerName, payload) => ({
  type: createActionName(
    reducerName,
    types.CHANGE_FIELD_EXECUTOR_EXECUTION_INTERVAL
  ),
  payload
});
export const changeFieldExecutorExecutionIntervalCheck = (
  reducerName,
  payload
) => ({
  type: createActionName(
    reducerName,
    types.CHANGE_FIELD_EXECUTOR_EXECUTION_INTERVAL_CHECK
  ),
  payload
});
export const changeFieldCheckDesc = (reducerName, payload) => ({
  type: createActionName(reducerName, types.CHANGE_FIELD_CHECK_DESC),
  payload
});
export const changeFieldRequireLinkInReport = (reducerName, payload) => ({
  type: createActionName(
    reducerName,
    types.CHANGE_FIELD_REQUIRE_LINK_IN_REPORT
  ),
  payload
});
export const changeFieldRequireScreenshotInReport = (reducerName, payload) => ({
  type: createActionName(
    reducerName,
    types.CHANGE_FIELD_REQUIRE_SCREENSHOT_IN_REPORT
  ),
  payload
});
export const changeFieldPExecutorEmailConfirm = (reducerName, payload) => ({
  type: createActionName(
    reducerName,
    types.CHANGE_FIELD_P_EXECUTOR_EMAIL_CONFIRM
  ),
  payload
});
export const changeFieldPHideForBlackList = (reducerName, payload) => ({
  type: createActionName(reducerName, types.CHANGE_FIELD_P_HIDE_FOR_BLACK_LIST),
  payload
});
export const changeFieldPMinRating = (reducerName, payload) => ({
  type: createActionName(reducerName, types.CHANGE_FIELD_P_EXECUTOR_MIN_RATING),
  payload
});
/**
 * Дейтвия управления викториной автоматической проверки задания
 * */
export const changeFieldQuizAddAsk = reducerName => ({
  type: createActionName(reducerName, types.CHANGE_FIELD_QUIZ_ADD_ASK)
});
export const changeFieldQuizDeleteAsk = (reducerName, payload) => ({
  type: createActionName(reducerName, types.CHANGE_FIELD_QUIZ_DELETE_ASK),
  payload
});
export const changeFieldQuizChangeAsk = (reducerName, payload) => ({
  type: createActionName(reducerName, types.CHANGE_FIELD_QUIZ_CHANGE_ASK),
  payload
});
export const changeFieldQuizAddAnswer = (reducerName, payload) => ({
  type: createActionName(reducerName, types.CHANGE_FIELD_QUIZ_ADD_ANSWER),
  payload
});
export const changeFieldQuizDeleteAnswer = (reducerName, payload) => ({
  type: createActionName(reducerName, types.CHANGE_FIELD_QUIZ_DELETE_ANSWER),
  payload
});
export const changeFieldQuizChangeAnswer = (reducerName, payload) => ({
  type: createActionName(reducerName, types.CHANGE_FIELD_QUIZ_CHANGE_ANSWER),
  payload
});

/**
 * Дейтвия управления таймтаргетингом
 */
export const changeFieldTimeTargetAddWeekdays = reducerName => ({
  type: createActionName(
    reducerName,
    types.CHANGE_FIELD_TIME_TARGET_ADD_WEEKDAYS
  )
});
export const changeFieldTimeTargetDeleteWeekdays = (reducerName, payload) => ({
  type: createActionName(
    reducerName,
    types.CHANGE_FIELD_TIME_TARGET_DELETE_WEEKDAYS
  ),
  payload
});
export const changeFieldTimeTargetChangeWeekdays = (reducerName, payload) => ({
  type: createActionName(
    reducerName,
    types.CHANGE_FIELD_TIME_TARGET_CHANGE_WEEKDAYS
  ),
  payload
});
export const changeFieldTimeTargetAddTimeRange = (reducerName, payload) => ({
  type: createActionName(
    reducerName,
    types.CHANGE_FIELD_TIME_TARGET_ADD_TIME_RANGE
  ),
  payload
});
export const changeFieldTimeTargetDeleteTimeRange = (reducerName, payload) => ({
  type: createActionName(
    reducerName,
    types.CHANGE_FIELD_TIME_TARGET_DELETE_TIME_RANGE
  ),
  payload
});
export const changeFieldTimeTargetChangeRangeFrom = (reducerName, payload) => ({
  type: createActionName(
    reducerName,
    types.CHANGE_FIELD_TIME_TARGET_CHANGE_TIME_RANGE_FROM
  ),
  payload
});
export const changeFieldTimeTargetChangeRangeTo = (reducerName, payload) => ({
  type: createActionName(
    reducerName,
    types.CHANGE_FIELD_TIME_TARGET_CHANGE_TIME_RANGE_TO
  ),
  payload
});

export const changeFieldTimeTargetChangeMaxAmount = (reducerName, payload) => ({
  type: createActionName(
    reducerName,
    types.CHANGE_FIELD_TIME_TARGET_CHANGE_TIME_MAX_AMOUNT
  ),
  payload
});

/**
 * Действия управления геотаргетингом
 */
export const changeFieldGeoTargetToggleItem = (
  reducerName,
  countryIsoCode,
  regionIsoCode,
  cityIsoCode
) => ({
  type: createActionName(
    reducerName,
    types.CHANGE_FIELD_GEO_TARGET_TOGGLE_ITEM
  ),
  payload: { countryIsoCode, regionIsoCode, cityIsoCode }
});
export const changeFieldGeoTargetChangeTypeComparison = (
  reducerName,
  countryIsoCodeRegions,
  regionIsoCodeCities,
  typeComparison
) => ({
  type: createActionName(
    reducerName,
    types.CHANGE_FIELD_GEO_TARGET_CHANGE_TYPE_COMPARISON
  ),
  payload: { countryIsoCodeRegions, regionIsoCodeCities, typeComparison }
});

// OTHER
export const clearLinkErrorByKey = (reducerName, payload) => ({
  type: createActionName(reducerName, types.CLEAR_LINK_ERROR_BY_KEY),
  payload
});
export const clearQuizAskErrorByKey = (reducerName, payload) => ({
  type: createActionName(reducerName, types.CLEAR_QUIZ_ASK_ERROR_BY_KEY),
  payload
});
export const clearQuizAnwerErrorByKeys = (reducerName, payload) => ({
  type: createActionName(reducerName, types.CLEAR_QUIZ_ANSWER_ERROR_BY_KEYS),
  payload
});



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/reducers/dynamic/taskFrom/actions.js